export function parseApiDate(value?: string): Date | undefined {
  if (!value) {
    return undefined;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? undefined : date;
}

export function parseOptionalApiDate(value?: string): Date | undefined {
  const date = parseApiDate(value);
  // The wire carries a cleared optional date as the epoch-zero Timestamp
  // ("1970-01-01T00:00:00Z" over REST JSON); the clear token is semantically
  // unset on read.
  return date?.getTime() === 0 ? undefined : date;
}

export function toApiTimestamp(value?: Date): string | undefined {
  if (!value) {
    return undefined;
  }
  return value.toISOString();
}

export function toDateInputValue(value?: Date): string {
  if (!value) {
    return "";
  }
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function fromDateInputValue(value: string): Date | undefined {
  if (!value) {
    return undefined;
  }
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) {
    return undefined;
  }
  return new Date(year, month - 1, day);
}

export function isOverdue(value?: Date, completed = false): boolean {
  if (!value || completed) {
    return false;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return value.getTime() < today.getTime();
}

export function formatDueDate(value: Date): string {
  return value.toLocaleDateString("zh-CN", {
    month: "short",
    day: "numeric",
  });
}
